import React, { useEffect, useState } from "react";
import styles from "./Login.module.css";
import { useNavigate } from "react-router-dom";
import config from "../../../settings/config";
import { useToast } from "../../../context/ToastContext";

const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [successButton, setSuccessButton] = useState(false);
    const { setToast } = useToast();
    
    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };

    useEffect(() => {
        if (username.length > 0 && password.length > 0) {
            setSuccessButton(true);
        } else {
            setSuccessButton(false);
        }
    }, [username, password]);


    const handleLogin = async (e) => {
        if (!successButton) {
            showToast("Заполните все поля!", "warn", 5000);
            return;
        }
        e.preventDefault();
        setLoading(true);

        const requestBody = {
            username,
            password,
            deviceId: "1",
        };

        try {
            const response = await fetch(`${config.app.host}/api/v1/auth`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || "Ошибка авторизации!");
            }

            const data = await response.json();
            localStorage.setItem("token", data.token);
            showToast("Вход выполнен!", "success", 3000);
            // Перенаправление пользователя после успешной авторизации
            navigate("/devices")
        } catch (err) {
            showToast(err.message, "error", 3000 );
        } finally {
            setLoading(false);
        }
    };

    const handleRegistration = () => {
        navigate('/registration')
    }

    const handleForgot = () => {
        navigate('/forgot')
    }

    return (
        <div className={styles.container}>
            {/* {toast && <CustomToast message={toast.message} type={toast.type} onClose={() => setToast(null)} />} */}
            <h3>Войти</h3>
            <div className={styles.form}>
                E-mail
                <input
                    className={styles.formInput}
                    type="text"
                    placeholder="Введите E-mail"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />

                Пароль
                <input
                    className={styles.formInput}
                    type="password"
                    placeholder="Введите пароль"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />

                <div className={styles.delimeterStyle}></div>

                <button
                    className={successButton ? styles.buttonContinueOn : styles.buttonContinue}
                    onClick={handleLogin}
                >
                    {loading ? "Вход..." : "Продолжить"}
                </button>
                <div className={styles.buttons}>
                    <button
                        className={styles.buttonRegistration}
                        onClick={handleRegistration}
                    >
                        Регистрация
                    </button>
                    <button
                        className={styles.buttonForget}
                        onClick={handleForgot}
                    >
                        Восстановить
                    </button>
                </div>
            </div>
            
        </div>
    );
};

export default Login;
